import cx from 'classnames';
import type { ReactNode } from 'react';
import type { DropdownItemProps, DropdownProps } from '../Dropdown';
import { Dropdown } from '../Dropdown';
import type { DefaultLinkImplementationProps, LinkImplementationRequiredProps, LinkProps } from '../Link';
import { Link } from '../Link';
import styles from './styles.module.css';

export type DropdownMenuProps<Values extends string = string> = DropdownProps<Values>;

export function DropdownMenu<Values extends string>(props: DropdownMenuProps<Values>): ReactNode {
  return <Dropdown large {...props} />;
}

export type DropdownMenuItemProps<P extends LinkImplementationRequiredProps> = LinkProps<P> & {
  onClick?: DropdownItemProps['onClick'];
  value?: DropdownItemProps['value'];
};

function DropdownMenuItem<P extends LinkImplementationRequiredProps = DefaultLinkImplementationProps>(
  props: DropdownMenuItemProps<P>,
): ReactNode {
  const { className, onClick, ...linkProps } = props;
  return (
    <Dropdown.Item className={cx(styles.Item, className)} onClick={onClick}>
      <Link noBold {...linkProps} />
    </Dropdown.Item>
  );
}

DropdownMenu.Item = DropdownMenuItem;
